import { render, staticRenderFns } from "./CRManualSelection.vue?vue&type=template&id=5e70612b&scoped=true"
import script from "./CRManualSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./CRManualSelection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRManualSelection.vue?vue&type=style&index=0&id=5e70612b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70612b",
  null
  
)

export default component.exports